<template>
        <div
            class="funnel-card"
            @click="openTab(funnelCard.link)"
            :data-ba-i="funnelCard.baIntelligenceTag"
        >
            <div class="thumb">
                <img :src="funnelCard.thumb.img"/>
                <div class="hover-div">
                    <span class="fa fa-external-link"></span>
                    {{funnelCard.thumb.text}}
                </div>
            </div>
            <div class="title">{{funnelCard.title}}</div>
            <div class="subtitle">{{funnelCard.subtitle}}</div>
            <div
                class="button"
                v-if="funnelCard.button != null"
                @click="openTab(funnelCard.button.link)"
                :data-ba-i="funnelCard.button.baIntelligenceTag"
            >{{funnelCard.button.label}}</div>
            
        </div>
</template>

<script>
    export default {
        name: 'funnel-card',
        props: ['view'],
        data: function() {
            return {
                link: '#',
                baIntelligenceTag: 'fc-c10-new-funnel-of-month-us-x-y',
                thumb: {
                    img: '/internacional/public/office4/img/onboarding-funnel/content-3/example_thumb.png',
                    text: 'Show Funnel'
                },
                title: 'Chat Bot Funnel',
                subtitle: "PFF004 EN - Weight Loss Detox",
                button: {
                    label: 'Download',
                    link: '#',
                    baIntelligenceTag: 'fc-c10-download-new-funnel-of-month-us-x-y'
                },
            };
        },
        methods: {
            openTab: function(link) {
                window.open(link, '_blank')
            },
        },
        computed: {
            funnelCard: function () {
                return (this.view !== undefined && this.view !== null) ? this.view : this.$data
            }
        }
    }
</script>

<style scoped lang="scss">
    @import "../../../../../scss/office";

    .funnel-card{
        font: inherit;
        display: flex;
        flex-direction: column;
        align-items: center;
        border: 1px $of-color24 solid;
        border-radius: 0.4em;
        padding: 0.8em 0.8em 2.4em 0.8em;

        .title{
            font: inherit;

            font-family: "Mulish";
            font-size: 2em;
            font-weight: 700;
            line-height: 1.2;
            margin-top: 0.6em; /* 12px */       

            display: flex;
            justify-content: space-evenly;
            align-items: center;

            padding-bottom: 0!important;
        }

        .thumb{
            font: inherit;

            border-radius: 0.4em; /*2px*/
            padding: 0.4em;
            min-height: 24em;
            min-width: 100%;
            box-sizing: border-box;
            
            border: 1px $of-color13 solid;

            display: flex;
            align-items: center;
            justify-content: center;
            position: relative;
            overflow: hidden;

            .hover-div{
                font: inherit;
                font-family: "Mulish";
                font-size: 1.5em;
                font-weight: 900;
                line-height: 1.2;
                transition: top 300ms;


                position: absolute;
                left: 0;
                top: 100%;

                width: 100%;
                height: 100%;

                display: flex;
                align-items: center;
                justify-content: center;
                flex-direction: column;

                color: $of-color3;
                background-color: rgba($of-color12, 0.5);
                
                span{
                    font-size: 24px;
                }
            }

            img{
                width: 100%;
                height: auto;
            }
        }

        .subtitle{
            font: inherit;
            font-family: "Mulish";
            font-size: 1.5em;
            font-weight: 700;
            line-height: 1.2;

            text-align: center;
            margin-top: 0.4em;
            padding-bottom: 0!important;
        }

        .button{
            font: inherit;
            color: $of-color3;
            font-weight: 900;
            margin-top: 1em;
            font-size: 1.2em;

            background-color: $of-color1;
            border-radius: 0.266666667em;
            padding: 0.5em 1em;

            &:hover{
                cursor: pointer;
                box-shadow: 0px 0px 7px -2px $of-color1;
            }
        }

        &:hover{
            cursor: pointer;
            .title,
            .subtitle{
                color: $of-color1;
            }

            .thumb{
                .hover-div{
                    top: 0;
                }
            }
        }
    }
</style>


// WEBPACK FOOTER //
// resources/office/js/components/dashboard/onboardingFunnel/content-10/FunnelCard.vue